var React = require('react');

function IconChatInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.375 2.999h7.906a.72.72 0 0 1 .719.719v7.906a8.618 8.618 0 0 1-2.527 6.099 8.638 8.638 0 0 1-6.099 2.527 8.618 8.618 0 0 1-6.099-2.527 8.638 8.638 0 0 1-2.527-6.099 8.627 8.627 0 0 1 8.625-8.625z","stroke":"currentColor","strokeWidth":"1.5","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.375 12.938a.94.94 0 0 0 .938-.937.94.94 0 0 0-.937-.937.94.94 0 0 0-.937.938.94.94 0 0 0 .938.938zm4.5 0a.94.94 0 0 0 .938-.937.94.94 0 0 0-.937-.937.94.94 0 0 0-.937.938.94.94 0 0 0 .938.938zm-9 0A.94.94 0 0 0 8.813 12a.94.94 0 0 0-.937-.937.94.94 0 0 0-.937.938.94.94 0 0 0 .938.938z","fill":"currentColor","key":1})]);
}

IconChatInline.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = IconChatInline;

IconChatInline.default = IconChatInline;
